import React, { HTMLAttributes } from 'react';
import Icon from './Icon';
import clsx from 'clsx';

interface ChipAttributes {
  children?: any;
  showDelete?: boolean;
  onDeleteClick?: Function;
  chipProps?: HTMLAttributes<HTMLDivElement>;
}

const Chip = (props: ChipAttributes) => {
  const {
    children,
    showDelete = true,
    chipProps = {},
    onDeleteClick,
  } = props;

  return (
    <div
      {...chipProps}
      className={clsx(
        `${chipProps.className ?? ''}`.trimEnd(),
        'flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gray-100 px-3 py-1.5 text-center text-sm'
      )}
    >
      {children}
      {showDelete && (
        <Icon
          name="close"
          cursor="pointer"
          className="h-4 w-4 text-gray-700"
          onClick={() => onDeleteClick && onDeleteClick()}
        />
      )}
    </div>
  );
};

export default Chip;
